<template>
  <div class="bank_details">
    <div class="d_top">{{$t('main.text271')}}</div>
    <div class="d_top2">{{$t('main.text272')}}</div>
    <div class="d_box">
        <div class="d_box_top">{{$t('main.text273')}}</div>
        <div class="d_box_body">
            <div class="alert_box">
                <el-alert
                    class="alert_style"
                    type="warning"
                    :closable="false"
                    show-icon>
                    <div slot="title" class="alert_text">
                        {{$t('main.text274')}}
                        <span class="alert_num">{{bank_info.reference}}</span>
                        {{$t('main.text275')}}
                    </div>
                </el-alert>
            </div>
            
            <div class="body_row">
                <div>
                    <div class="body_row_t1">{{$t('main.text276')}}</div>
                    <div class="body_row_t2">{{bank_info.beneficiaryBank}}</div>
                </div>
                <div>
                    <div class="body_row_t1">{{$t('main.text277')}}</div>
                    <div class="body_row_t2">{{bank_info.bankAddress}}</div>
                </div>
            </div>
            
            <div class="body_row">
                <div>
                    <div class="body_row_t1">{{$t('main.text278')}}</div>
                    <div class="body_row_t2">{{bank_info.bankCountry}}</div>
                </div>
                <div>
                    <div class="body_row_t1">{{$t('main.text279')}}</div>
                    <div class="body_row_t2">{{bank_info.swiftCode}}</div>
                </div>
            </div>
            
            <div class="body_row">
                <div>
                    <div class="body_row_t1">{{$t('main.text280')}}</div>
                    <div class="body_row_t2">{{bank_info.intermediaryBank}}</div>
                </div>
                <div>
                    <div class="body_row_t1">{{$t('main.text281')}}</div>
                    <div class="body_row_t2">{{bank_info.intermediaryBankSwiftCode}}</div>
                </div>
            </div>
            <div class="body_row">
                <div>
                    <div class="body_row_t1">{{$t('pdf.text34')}}</div>
                    <div class="body_row_t2">{{bank_info.accountName}}</div>
                </div>
                <div>
                    <div class="body_row_t1">{{$t('main.text282')}}</div>
                    <div class="body_row_t2">{{bank_info.accountNumber}}</div>
                </div>
            </div>
            
            <div class="body_row">
                <div>
                    <div class="body_row_t1">{{$t('main.text283')}}</div>
                    <div class="body_row_t2">{{bank_info.currency}}</div>
                </div>
            </div>
            
            <div class="body_row">
                <div>
                    <div class="body_row_t1"></div>
                    <div class="body_row_t2"></div>
                    <div>
                        <el-button class="body_row_btn border_set_color" @click="Copy()" size="medium">{{$t('main.text285')}}</el-button>
                    </div>
                </div>
                <div>
                    <div class="body_row_t1"></div>
                    <div class="body_row_t2"></div>
                </div><div>
                    <div class="body_row_t1"></div>
                    <div class="body_row_t2"></div>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import cryptoJS from 'crypto-js'
// 加密 解密  https://blog.csdn.net/weixin_47424753/article/details/126331686
export default {
    data() {
        return {
            bank_info:{},
            deposit_code:'XXX',
            
        }
    },
    beforeMount() {
        this.$nextTick(()=>{
            this.bus.$on('bank_info_data',(v)=>{
                this.bank_info=v;
                sessionStorage.removeItem('top_title_name',v.currency);
                // console.log(v);
            });
        })
    },
    mounted() {
        let bank_info_data = sessionStorage.getItem("bank_info_data")||'';
        if(bank_info_data){
            this.bank_info = this.info_decode(bank_info_data);
            sessionStorage.setItem('top_title_name',this.$t('main.text687')+this.bank_info.currency);
            // console.log(this.bank_info);
        }
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
    },
    methods: {
        //复制
        copy_api(v) {
            const input = document.createElement("input");
            document.body.appendChild(input);
            input.setAttribute("value", v);
            input.select();
            if (document.execCommand("copy")) {
                document.execCommand("copy");
            }
            document.body.removeChild(input);
            this.message.ismessage('success',this.$t('main.text297'));
            // this.$message.success("复制成功");
        },

        Copy() {
            return new Promise(resolve => {
                let copy_string=
                this.$t('main.text276')+'：'+this.bank_info.beneficiaryBank+"\r\n"+
                this.$t('main.text277')+'：'+this.bank_info.bankAddress+"\r\n"+
                this.$t('main.text278')+'：'+this.bank_info.bankCountry+"\r\n"+
                this.$t('main.text279')+'：'+this.bank_info.swiftCode+"\r\n"+
                this.$t('main.text280')+'：'+this.bank_info.intermediaryBank+"\r\n"+
                this.$t('main.text281')+'：'+this.bank_info.intermediaryBankSwiftCode+"\r\n"+
                this.$t('pdf.text34')+'：'+this.bank_info.accountName+"\r\n"+
                this.$t('main.text282')+'：'+this.bank_info.accountNumber+"\r\n"+
                this.$t('main.text283')+'：'+this.bank_info.currency;

                const copyUrl = document.createElement("textarea"); //创建一个textarea框获取需要复制的文本内容
                copyUrl.value = copy_string;
                const appDiv = document.getElementById("app");
                appDiv.appendChild(copyUrl);
                copyUrl.select();
                document.execCommand("Copy");
                copyUrl.remove();
                resolve(true);
                this.message.ismessage('success',this.$t('main.text297'));
            });
        },
        cryptojsDecrypt(word, keyStr, ivStr) {
            let key = cryptoJS.enc.Utf8.parse(keyStr);
            let iv = cryptoJS.enc.Utf8.parse(ivStr);
            // let srcs = cryptoJS.enc.Utf8.parse(word);

            let decrypted = cryptoJS.AES.decrypt(word, key, {
                iv,
                mode: cryptoJS.mode.CBC,
                padding: cryptoJS.pad.Pkcs7
            });
            // return decrypted.toString();
            return cryptoJS.enc.Utf8.stringify(decrypted).toString();
        },
        // cryptojsDecrypt(返回给你的字符串,key, iv);
        info_decode(v){
            let key= "6P7t47zj3dnh5isx";
            let iv= "hrYjdyJ2nBjdKB6G";
            let str1 =  this.cryptojsDecrypt(v,key,iv);
            // console.log(str1);
            return JSON.parse(str1);
        }
    },
}
</script>

<style scoped>
.d_top{
    /* margin-top: 46px; */
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 4px;
}
.d_top2{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: #FFFFFF;
    opacity: 0.8;
    margin-bottom: 20px;
}
.d_box{
    background: #314B69;
    border-radius: 16px;
    overflow: hidden;
}
.d_box_top{
    box-sizing: border-box;
    padding: 20px 28px;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    border-bottom: 1.5px solid #041E35;
}
.d_box_body{
    box-sizing: border-box;
    padding: 28px;
}
.alert_box{
    min-height: 64px;
}
.body_row{
    display: flex;
    margin-top: 28px;
    justify-content: space-between;
}
.body_row>div{
    width: 31%;
}
.body_row_t1{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.6;
}
.body_row_t2{
    margin-top: 8px;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
}
.body_row_btn,
.body_row_btn:hover{
    min-width: 200px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #DEB981;
    background: transparent;
    border-style:solid;
    border-width: 1.5px;
    border-color:#ECBD75 #E3A84E #ECBC74 #F1C788;
}

</style>
